import { CheckCircle2, LayoutTemplate, Loader2, SquarePen } from "lucide-react";
import CamposModelo from "./CamposModelo";
import EditorMensagem from "./EditorMensagem";
import { STATUS, nomeAmigavel, partesDoModelo } from "./modelos";

function Aba({ ativa, onClick, icone: Icone, children }) {
  return (
    <button type="button" onClick={onClick}
      className={`flex-1 inline-flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
        ativa ? "bg-background shadow-sm text-foreground" : "text-muted-foreground hover:text-foreground"}`}>
      <Icone className="h-4 w-4" /> {children}
    </button>
  );
}

function CartaoModelo({ modelo, ativo, onClick }) {
  const aprovado = modelo.status === "APPROVED";
  const s = STATUS[modelo.status] || { rotulo: modelo.status, cls: "text-muted-foreground bg-muted" };
  const trecho = partesDoModelo(modelo).corpo.replace(/\{\{\d+\}\}/g, "…");
  return (
    <button type="button" onClick={aprovado ? onClick : undefined} disabled={!aprovado}
      className={`w-full text-left rounded-xl border p-3 transition-colors ${
        ativo ? "border-[#25d366] bg-[#25d366]/10 ring-1 ring-[#25d366]" : aprovado ? "hover:bg-muted/60" : "opacity-70 cursor-default"}`}>
      <div className="flex items-center gap-2">
        <span className="font-semibold text-sm flex-1 truncate">{nomeAmigavel(modelo.name)}</span>
        {ativo ? <CheckCircle2 className="h-4 w-4 text-[#25d366]" />
          : <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${s.cls}`}>{s.rotulo}</span>}
      </div>
      <p className="mt-1 text-xs text-muted-foreground line-clamp-2">{trecho}</p>
    </button>
  );
}

/**
 * Passo 1 da campanha: escolher um modelo aprovado (e dizer o que entra em
 * cada campo) ou escrever a mensagem da loja. Tudo se edita aqui na página;
 * o celular ao lado só mostra.
 */
export default function EscolherModelo({
  modo, setModo, modelos, escolhido, onEscolher, campos, setCampos, editor,
}) {
  const partes = escolhido ? partesDoModelo(escolhido) : null;
  return (
    <div className="space-y-4">
      <div className="flex gap-1 rounded-xl bg-muted p-1">
        <Aba ativa={modo === "prontos"} onClick={() => setModo("prontos")} icone={LayoutTemplate}>Modelos prontos</Aba>
        <Aba ativa={modo === "criar"} onClick={() => setModo("criar")} icone={SquarePen}>Escrever a minha</Aba>
      </div>

      {modo === "criar" ? (
        <EditorMensagem {...editor} />
      ) : modelos === null ? (
        <p className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Carregando modelos…</p>
      ) : !modelos.length ? (
        <div className="rounded-xl border border-dashed p-5 text-center text-sm text-muted-foreground">
          Nenhum modelo ainda.{" "}
          <button type="button" onClick={() => setModo("criar")} className="font-semibold text-primary">Escreva a sua mensagem</button>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
            {modelos.map((m) => (
              <CartaoModelo key={m.name} modelo={m} ativo={escolhido?.name === m.name} onClick={() => onEscolher(m)} />
            ))}
          </div>
          {escolhido && (
            <CamposModelo corpo={partes.corpo} campos={campos} setCampos={setCampos} />
          )}
        </>
      )}
    </div>
  );
}
